<template>
  <div class="objetive__container">
    <div v-if="!isEdition">
      <span class="objetive-index">
        {{ `${mainIndex}.${index}` }}
      </span>
      {{ value.objectiveDescription }}
    </div>
    <div v-else class="objetive-edition__container">
      <ValidationObserver
        ref="objetiveForm"
        tag="form"
        class="d-flex"
        novalidate
      >
        <span class="objetive-index">
          {{ `${mainIndex}.${index}` }}
        </span>
        <ValidationProvider
          v-slot="{ errors }"
          style="width: 65vw"
          rules="required"
        >
          <CustomTextArea
            v-model="descriptionTosave"
            :show-char-count="false"
            :error="errors[0]"
            :maxlength="500"
            :disabled="isReadOnly"
            custom-error-msg="El campo es requerido."
          />
        </ValidationProvider>
      </ValidationObserver>
    </div>
    <div v-if="!isReadOnly" class="objetive__actions">
      <ActionButton
        v-if="isEdition"
        i="fa fa-times-circle ml-2"
        class="mr-2 button-size"
        variant="outline-danger"
        @click="isEdition = false"
      />
      <ActionButton
        v-else
        i="fa fa-times-circle ml-2"
        class="mr-2 button-size"
        variant="outline-danger"
        @click="deleteObjetive"
      />
      <ActionButton
        v-if="!isEdition"
        i="fa fa-pencil ml-2"
        class="button-size"
        variant="success"
        @click="isEdition = true"
      />
      <ActionButton
        v-else
        i="fa fa-save ml-2"
        class="button-size"
        variant="success"
        @click="saveObjetive"
      />
    </div>
  </div>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import ActionButton from '@/components/common/ActionButton';
import CustomTextArea from '@/components/common/CustomTextArea';

export default {
  name: 'ObjetiveItem',
  mixins: [alert],
  components: {
    ActionButton,
    CustomTextArea
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        objectiveDescription: '',
      })
    },
    mainIndex: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdition: false,
      descriptionTosave: this.value.objectiveDescription
    };
  },
  methods: {
    async deleteObjetive() {
      let confirmDeletion = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro que desea eliminar el objetivo: ${this.value.objectiveDescription}?`,
        'Si',
        'No'
      );

      if (!confirmDeletion) return;

      this.$emit('delete-objetive', parseInt(this.value.peiProgramServiceObjectivelId));
    },
    async saveObjetive() {
      if (this.descriptionTosave == this.value.objectiveDescription) {
        this.isEdition = false;
        return;
      }

      const isValid = await this.$refs.objetiveForm.validate();
      if (!isValid) return;

      const payload = {
        peiProgramServiceObjectivelId: parseInt(this.value.peiProgramServiceObjectivelId),
        objectiveDescription: this.descriptionTosave,
        measure1Amt: parseInt(this.value.measure1Amt),
        measure2Amt: parseInt(this.value.measure2Amt),
        peiObjectiveMeasureCode: parseInt(this.value.peiObjectiveMeasureCode),
        peiProgramServiceGoalId: parseInt(this.value.peiProgramServiceGoalId),
      };

      this.$emit('update-objetive', payload);
      this.isEdition = false;
    },
  },
  watch: {
    isEdition() {
      this.descriptionTosave = this.value.objectiveDescription;
    }
  },
};
</script>

<style scoped>
.objetive__container {
  justify-content: space-between;
  display: flex;
  align-items: center;
  padding: 15px;
}

.objetive-index {
  font-weight: bold;
  margin-right: 20px;
}

.objetive-edition__container {
  display: flex;
  align-items: center;
  width: 50vw;
}

.objetive__actions {
  display: flex;
  align-items: center;
}

.button-size {
  height: 45px;
}
</style>